module.exports = __webpack_public_path__ + "static/img/62.d8c27c3d.jpg";